import { CommentInputComponent } from "@/shared/components/comment-component";
import { ReactElement, useState } from "react";
import { BatchComponent } from "@/shared/components/domain/samples/batch-component";
import { Card } from "@/shared/components/ui/card";
import { Sample } from "@/services/backend/sample-set/sample-set";
import {
  UpdateSampleRequest,
  useUpdateSampleMutation,
} from "@/services/backend/sample-set/service";
import { useDebouncedMutationWithPersistenceStateContextUpdate } from "@/shared/lib/debounce/debounce";
import ErrorBadge from "./error-badge";

interface SampleMetadataRowProps {
  sampleSetId: string;
  sample: Sample;
}

function SampleMetadataRow({
  sampleSetId,
  sample,
}: SampleMetadataRowProps): ReactElement {
  const [updateSample, { isLoading, error, isSuccess, reset }] =
    useUpdateSampleMutation();
  const [updateRequest, setUpdateRequest] = useState<UpdateSampleRequest>({
    sampleSetId,
    sample,
  });
  useDebouncedMutationWithPersistenceStateContextUpdate(
    updateRequest,
    updateSample,
    isLoading,
    error,
    isSuccess,
    reset,
    500,
  );

  const submitHandler = (comment: string) => {
    setUpdateRequest({
      ...updateRequest,
      sample: { ...updateRequest.sample, comment },
    });
  };

  return (
    <Card className="flex flex-row items-center justify-between p-4">
      <div className="flex flex-col items-start space-y-2">
        <p className="font-bold">Charge:</p>
        <BatchComponent batch={sample.batch} />
      </div>
      <div className="flex flex-col items-start space-y-2">
        <p className="font-bold">Fehler:</p>
        <div className="flex flex-row space-x-1">
          {sample.sampleErrors != null && sample.sampleErrors.length > 0 ? (
            sample.sampleErrors.map((sampleError) => (
              <ErrorBadge key={sampleError.id} sampleError={sampleError} />
            ))
          ) : (
            <p>Keine Fehler vorhanden</p>
          )}
        </div>
      </div>
      <div className="flex flex-col items-start space-y-2">
        <p className="font-bold">Kommentar:</p>
        <CommentInputComponent
          disabled={false}
          comment={sample.comment}
          submitHandler={(comment) => submitHandler(comment)}
        />
      </div>
    </Card>
  );
}

export default SampleMetadataRow;
